import React, { Component } from 'react';
import LoginComponent from './LoginComponent';
import ForgotPassword from './ForgotPasswordComponent';
import Changepassword from './ChangePasswordComponent';
import UnderMaintananceComponent from './UnderMaintananceComponent'
import Select, { components } from "react-select";
import i18n from '../i18n';
import { withTranslation, Trans } from 'react-i18next';
import * as CookieService from '../CookieService';
import SDIConstants, { ConvertToEst } from '../SDIConstants';
const options = [
    {
        value: 'en', label: 'English', icon:
            "http://purecatamphetamine.github.io/country-flag-icons/3x2/US.svg"
    },
    {
        value: 'es', label: 'Español', icon: "http://purecatamphetamine.github.io/country-flag-icons/3x2/MX.svg"
    },
    {
        value: 'fr', label: 'Français', icon: "http://purecatamphetamine.github.io/country-flag-icons/3x2/FR.svg"
    }
]

const { Option } = components;
const IconOption = props => (
    <Option {...props}>
        <img
            src={props.data.icon}
            alt={props.data.label}
            style={{ "width": "12px" }}
        />
        {" "}
        {props.data.label}
    </Option>
);
class BgOverlayComponent extends Component {
    constructor(props) {
        super(props);
        this.ZeuslogoClick = this.ZeuslogoClick.bind(this);
        this.DisplayOutageData = this.DisplayOutageData.bind(this);
        //PC_WW-617_25-Getting contact details-Priyanka D
        this.state = {
            WalPhone: CookieService.getLocalStorageValues("WAL_PHONE_NUM") != null && CookieService.getLocalStorageValues("WAL_PHONE_NUM") != undefined ? CookieService.getLocalStorageValues("WAL_PHONE_NUM") : "",
            WalEmail: CookieService.getLocalStorageValues("WAL_EMAIL_ID") != null && CookieService.getLocalStorageValues("WAL_EMAIL_ID") != undefined ? CookieService.getLocalStorageValues("WAL_EMAIL_ID") : "",
            WalContactFlag: CookieService.getLocalStorageValues("WAL_CONTACT_FLAG") != undefined ? CookieService.getLocalStorageValues("WAL_CONTACT_FLAG") : "",
            language: CookieService.getLocalStorageValues("newlanguage") != null && CookieService.getLocalStorageValues("newlanguage") != undefined && CookieService.getLocalStorageValues("newlanguage") != false ? CookieService.getLocalStorageValues("newlanguage") : options[0], logoclkcnt: 0, showlogin: CookieService.getLocalStorageValues("ShowNormalLogin") != null && CookieService.getLocalStorageValues("ShowNormalLogin") != undefined ? CookieService.getLocalStorageValues("ShowNormalLogin") : false,
            lastversion: CookieService.getLocalStorageValues("lastVersion"),
            displayText: "",
            isredirect: "",
            resultMessage: ""
        }
    }

    DisplayOutageData = (isredirect, displayText, result) => {
        CookieService.updateLocalStorageValues("displayText", displayText);
        CookieService.updateLocalStorageValues("isredirect", isredirect);
        CookieService.updateLocalStorageValues("resultMessage", result);
        this.setState({
            displayText: displayText,
            isredirect: isredirect,
            resultMessage: result
        });

        return
    }

    //PC_WW-617_33-Getting contact details-Priyanka D
    ContactDetailsUpdate = (ContactFlag) => {
        
        let Phone = CookieService.getLocalStorageValues("WAL_PHONE_NUM");
        let Email = CookieService.getLocalStorageValues("WAL_EMAIL_ID");
        this.setState({ WalPhone: Phone, WalEmail: Email, WalContactFlag: ContactFlag });

    }
    onLanguageHandle = (event) => {
        
        let newobj = event;
        let newLang = event.value;
        
        CookieService.updateLocalStorageValues("oldlanguage", newLang);
        CookieService.updateLocalStorageValues("newlanguage", newobj);
        console.log("bgmlang", CookieService.getLocalStorageValues("newlanguage"))

        let Filecheck = CookieService.getLocalStorageValues("resultMessage");
        if (Filecheck) {
            const localStorageLanguageCode = CookieService.getLocalStorageValues("newlanguage") ? CookieService.getLocalStorageValues("newlanguage") : options[0];
            let result  = Filecheck;
            let isredirect = CookieService.getLocalStorageValues("isredirect");
            const langResult = result[0].messages;
            const displayDateTimeStart = ConvertToEst(result[0].displayDateTimeStart);
            const outageDateTimeStart = ConvertToEst(result[0].outageDateTimeStart);
            const outageDateTimeEnd = ConvertToEst(result[0].outageDateTimeEnd);

            const filteredLangResult = langResult.find(msg => msg.languageCode === localStorageLanguageCode.value);
            let externalMessage = filteredLangResult && filteredLangResult.externalMessage;
            externalMessage = externalMessage
                .replace('outageDateTimeStart', outageDateTimeStart)
                .replace('outageDateTimeEnd', outageDateTimeEnd);

            this.setState({
                displayText: externalMessage,
            })
            this.DisplayOutageData(isredirect, externalMessage, Filecheck)
        }
        i18n.changeLanguage(newLang);
        this.setState({ language: newobj });
    };

    componentDidMount() {
        
        let lastversion = this.state.lastversion;
        if (lastversion != undefined) {
            CookieService.updateLocalStorageValues("lastVersion", lastversion);
        }
        if (this.state.showlogin == true) {
            this.setState({ logoclkcnt: 3 });
        }
    }

    //[12/20/2022]WW-456 ZeuslogoClick() will be hit onclick of zeus logo, click count will be incremented and sent to logincomp to show normal login page if count is 3
    ZeuslogoClick = () => {
        let logoclick = this.state.logoclkcnt + 1;
        if (logoclick == 4) {
            logoclick = 0;
            CookieService.updateLocalStorageValues("SSOFirstHit", true);
        }
        if (logoclick == 3) {
            CookieService.updateLocalStorageValues("LoginFirstHit", true)
        }
        this.setState({ logoclkcnt: logoclick, showlogin: CookieService.getLocalStorageValues("ShowNormalLogin") });
    }

    removeHTMLTags(text) {
        const div = document.createElement('div');
        div.innerHTML = text;
        return div.textContent || div.innerText || '';
    }

    render() {
        console.log("statebgmlang", this.state.language);
        let displayText = CookieService.getLocalStorageValues("displayText");
        let isredirect = CookieService.getLocalStorageValues("isredirect");

        let lastversion = this.state.lastversion;
        if (lastversion != undefined) {
            CookieService.updateLocalStorageValues("lastVersion", lastversion);
        }
        let bodyComponent;
        if (this.props.location.pathname.toLowerCase().indexOf('forgotpassword') >= 0) {
            bodyComponent = <ForgotPassword title={this.props.title} DisplayOutageData={(isredirect, externalMessage, result) => this.DisplayOutageData(isredirect, externalMessage, result)} {...this.props} />
        }
        else if (this.props.location.pathname.toLowerCase().indexOf('changepassword') >= 0) {
            bodyComponent = <Changepassword title={this.props.title} DisplayOutageData={(isredirect, externalMessage, result) => this.DisplayOutageData(isredirect, externalMessage, result)} {...this.props} />
        }
        else if (this.props.location.pathname.toLowerCase().indexOf('undermaintanance') >= 0) {
            bodyComponent = <UnderMaintananceComponent title={this.props.title} {...this.props} />
        }
        else {
            bodyComponent = <LoginComponent title={this.props.title} lastversion={this.state.lastversion} propslang={this.state.language} logoClickCount={this.state.logoclkcnt} showNormalLogin={this.state.showlogin} ContactDetailsUpdate={this.ContactDetailsUpdate} DisplayOutageData={(isredirect, externalMessage, result) => this.DisplayOutageData(isredirect, externalMessage, result)} {...this.props} />
        }
        return (<div className="container-fluid custom-spacing-style" id="Log-in">
            {this.props.location.pathname.toLowerCase().indexOf('undermaintanance') >= 0 ?

                <div>{bodyComponent}</div> :
                <div className="row">
                    <div className="login-bg col-12 col-sm-12 col-md-12 col-lg-4 d-none d-lg-block p-0 ">
                        <div className="position-absolute col-12  text-center banner-content">
                            <h3 className="font-22 banner-heading"><Trans>SDI MRO for a more</Trans><span className="font-bold"><Trans>connected </Trans></span>
                                <Trans> enterprise </Trans></h3>
                            <span className="font-10 copyright">{`© 2013-${new Date().getFullYear().toString()} sdi, inc. `}<Trans>All rights reserved.</Trans></span>
                        </div>
                    </div>

                    <div class="Login-form col-12 col-sm-12 col-md-12 col-lg-8">

                        <div class="row justify-content-center sdi-custom-automargin ">
                            <div class="col-lg-8 col-md-12">
                                <div class="row justify-content-end">
                                    <div class="col-4 col-md-3 mb-2">

                                        <Select
                                            id="translation_DD"
                                            name="translationSelected"
                                            className="DropDown-Font-Size "
                                            onChange={(e) => this.onLanguageHandle(e)}
                                            value={this.state.language}
                                            defaultValue={options[0]}
                                            options={options}
                                            components={{ Option: IconOption }}
                                            style={{ backgroundColor: '#ADD8E6' }}
                                        />
                                    </div>
                                </div>
                                <div class="row justify-content-center">
                                    <div class="col-md-7 col-12 align-self-center login-shape-2">
                                        <div className="col-12 mb-3 mx-auto text-center">
                                            <img src="/Images/zeus-logo.png" alt="Logo" className="logo header-logo" onClick={this.ZeuslogoClick} />
                                        </div>

                                        {bodyComponent}
                                    </div>
                                </div>
                            </div>
                            {isredirect == "True" && displayText ?
                                <div className="custom-under-maintenance d-inline-block">
                                    <div className="d-flex align-items-start alert-container">
                                        <img className="alert-icon" src="images/improtent.svg" alt="" />
                                        <p className="m-0 text-white ">
                                            {this.removeHTMLTags(displayText)}
                                        </p>
                                    </div>
                                </div> : null}

                            <div class="col-md-12 mx-auto footer-logo text-center">
                                <div class="row">
                                    <div className="col-md-12">

                                        {/*pc-WW-1106-01 S.Sanjay 07/08/2024*/}
                                        <img src="/Images/core5.png" alt="footer-logo" className="core-5" />
                                        <span className="core-links">
                                            <span className=" footer-content m-1 d-inline-block"><Trans>Speed to Execution</Trans></span>
                                            <span className="slash">/</span>
                                            <span className=" m-1 footer-content d-inline-block"><Trans>Agility</Trans></span>
                                            <span className="slash">/</span>
                                            <span className=" m-1 footer-content d-inline-block"><Trans>One SDI</Trans></span>
                                            <span className="slash">/</span>
                                            <span className=" m-1 footer-content d-inline-block"><Trans>Operation Excellence</Trans></span>
                                            <span className="slash">/</span>
                                            <span className=" m-1 footer-content d-inline-block"><Trans>Courage</Trans></span>
                                        </span>
                                        <img src="/Images/sdi logo.png" alt="SDi Logo" />
                                    </div>
                                    <div className="col-md-12 sdi-footer-text-break">
                                        <p className="font-12 mt-3">
                                            {this.state.WalContactFlag != "" && this.state.WalContactFlag != null ? this.state.WalContactFlag == "P" || this.state.WalContactFlag == "PE" ? <a href={`tel:+${this.state.WalPhone}`} className="footer-info mr-2 pr-2">{`Call Us: ${this.state.WalPhone}`}</a> : null : null}
                                            <a href="http://www.sdi.com/" className="footer-info mr-2 pr-2">http://www.sdi.com/</a>
                                            {this.state.WalContactFlag != "" && this.state.WalContactFlag != null ? this.state.WalContactFlag == "E" || this.state.WalContactFlag == "PE" ? <a href={`mailto:${this.state.WalEmail}`} className="footer-info mr-2 pr-2"><Trans>{this.state.WalEmail}</Trans></a> : null : null}
                                        </p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>}
        </div>)
        {/*<div className="col-md-8 p-0 Login-form" >
                    <div className="col-2 float-right" style={{ "marginRight": "8%", "marginLeft": "-25%", "marginTop": "5%" }}>
                        <Select 
                            id="pickupstore_DD"
                            name="PickupStoreSelected"
                            className="DropDown-Font-Size "
                            onChange={(e) => this.onLanguageHandle(e)}
                            value={this.state.language}
                            defaultValue={options[0]}
                            options={options}
                            components={{ Option: IconOption }} 
                            style={{ backgroundColor: '#ADD8E6'}}
                        /></div>
                    <div className="row mx-0">
                        <div className="col-lg-4 col-md-8 col-11 p-0 mx-auto login-margin text-center login-shape-2">
                            
                            <div className="col-12 mb-3 mx-auto p-0">
                                <img src="/Images/zeus-logo.png" alt="Logo" className="logo header-logo" />
                            </div>
                        {bodyComponent}
                        </div>
                        <div className="col-12 p-0 mx-auto footer-logo text-center">
                            <div className="col-12">
                                {/* <img src="images/footer-logo.png" alt="footer-logo" class="mob-w-100">
                                <img src="/Images/core6.png" alt="footer-logo" />
                                <span className="core-links">
                                    <span className=" footer-content m-1 d-inline-block"><Trans>Speed to Execution</Trans></span>
                                    <span className="slash">/</span>
                                    <span className=" m-1 footer-content d-inline-block"><Trans>Simplify</Trans></span>
                                    <span className="slash">/</span>
                                    <span className=" m-1 footer-content d-inline-block"><Trans>Commitment</Trans></span>
                                    <span className="slash">/</span>
                                    <span className=" m-1 footer-content d-inline-block"><Trans>Perseverance</Trans></span>
                                    <span className="slash">/</span>
                                    <span className=" m-1 footer-content d-inline-block"><Trans>Courage</Trans></span>
                                    <span className="slash">/</span>
                                    <span className=" m-1 footer-content d-inline-block"><Trans>Solution-Oriented</Trans></span>
                                </span>
                                <img src="/Images/sdi logo.png" alt="SDi Logo" />
                            </div>
                            <div className="col-12">
                                <p className="font-12 mt-3">
                                    <span className="footer-info mr-2 pr-2"><Trans>Call us</Trans><span>: 855-446-9423</span></span>
                                    <a href="http://www.sdi.com/" className="footer-info mr-2 pr-2">http://www.sdi.com/</a>
                                    <a href="mailto:WalmartPurchasing@sdi.com" className="footer-info mr-2 pr-2"><Trans>contact sdi customer care</Trans></a></p>
                            </div>
                        </div>
                    </div>
                   </div>
            </div>
        </div>)*/}


    }
}
export default withTranslation()(BgOverlayComponent);